import React, { useState, useEffect } from "react";
import "./RecomendMe.css";
import "../App.css";
import DualPriceSlider from "../components/DualPriceSlider";
import axios from "axios";
import image from "../assets/mat.png";
import { useNavigate } from "react-router-dom";

function RecomendMe() {
  const [startQuestions, setStartQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [reviewMode, setReviewMode] = useState(false);
  const [priceRange, setPriceRange] = useState([1000, 10000]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (startQuestions) {
      setCurrentQuestionIndex(0);
      setHistory([0]);
    }
  }, [startQuestions]);

  const handleStartQuestions = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/v1/questions`)
      .then((response) => {
        const orderedQuestions = response.data.sort((a, b) => a.id - b.id);
        setQuestions(orderedQuestions);
        setStartQuestions(true);
      })
      .catch((error) => console.error("Erro ao buscar perguntas:", error))
      .finally(() => setLoading(false));
  };

  const navigateToNextQuestion = (questionId, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: value,
    }));

    const currentQuestion = questions.find((q) => q.id === questionId);

    if (currentQuestion?.conditional && currentQuestion.conditional[value]) {
      const nextQuestionId = currentQuestion.conditional[value];
      const nextQuestionIndex = questions.findIndex(
        (q) => q.id === nextQuestionId
      );
      if (nextQuestionIndex !== -1) {
        setCurrentQuestionIndex(nextQuestionIndex);
        setHistory((prevHistory) => [...prevHistory, nextQuestionIndex]);
        return;
      }
    }

    if (currentQuestionIndex < questions.length - 1) {
      const nextIndex = currentQuestionIndex + 1;
      setCurrentQuestionIndex(nextIndex);
      setHistory((prevHistory) => [...prevHistory, nextIndex]);
    } else {
      setReviewMode(true);
    }
  };

  const handleAnswerChange = (questionId, value) => {
    navigateToNextQuestion(questionId, value);
  };

  const handlePriceChange = (values) => {
    setPriceRange(values);
  };

  const confirmPriceRange = () => {
    handleAnswerChange(
      questions[currentQuestionIndex].id,
      `${priceRange[0]} - ${priceRange[1]}`
    );
  };

  const handleBack = () => {
    if (reviewMode) {
      setReviewMode(false);
    } else if (history.length > 1) {
      const newHistory = history.slice(0, -1);
      setHistory(newHistory);
      setCurrentQuestionIndex(newHistory[newHistory.length - 1]);
    }
  };

  const progressPercentage = reviewMode
    ? 100
    : ((history.length - 1) / questions.length) * 100;

  const renderMultipleChoiceOptions = (options) =>
    options.map((option) => (
      <button
        key={option.id}
        className="btn-option-dark"
        onClick={() =>
          handleAnswerChange(questions[currentQuestionIndex].id, option.id)
        }
      >
        {option.label}
      </button>
    ));

  const renderSlider = () => (
    <DualPriceSlider
      minPrice={questions[currentQuestionIndex]?.minValue || 1000}
      maxPrice={questions[currentQuestionIndex]?.maxValue || 20000}
      onChange={handlePriceChange}
      disabled={false}
    />
  );

  const handleConfirmAnswers = () => {
    const queryParams = questions
      .map((question) => {
        const answer = answers[question.id];
        if (!answer) return null;

        if (question.type === "drag") {
          const [min, max] = answer.split(" - ").map((v) => parseInt(v, 10));
          return [`minPrice=${min}`, `maxPrice=${max}`];
        }

        const selectedOption = question.options?.find(
          (opt) => opt.id === answer
        );

        if (
          question.key &&
          selectedOption &&
          selectedOption.value !== null &&
          selectedOption.value !== undefined &&
          selectedOption.value !== ""
        ) {
          return `${question.key}=${encodeURIComponent(selectedOption.value)}`;
        }

        return null;
      })
      .filter(Boolean)
      .flat()
      .join("&");

    navigate(`/top3${queryParams ? `?${queryParams}` : ""}`);
  };

  return (
    <div className="main-container-dark">
      <div className="recomend-me-container-dark">
        {loading && (
          <div className="loading-indicator-dark">
            <div className="spinner"></div>
            <p>Carregando...</p>
          </div>
        )}

        {!startQuestions ? (
          <div className="mat-speech-container">
            <img src={image} alt="Mat" className="mat-image" />
            <div className="mat-speech-bubble">
              <h2>Olá, eu sou o Mat!</h2>
              <p>
                Vou ajudar você a escolher o melhor notebook para o seu perfil.
              </p>
              <button
                className="cta-button-dark"
                onClick={handleStartQuestions}
                disabled={loading}
              >
                {loading ? "Carregando..." : "Iniciar"}
              </button>
            </div>
          </div>
        ) : reviewMode ? (
          <div className="card-dark">
            <div className="recomend-me-card-body-dark">
              <div className="progress-dark mb-3">
                <div
                  className="progress-bar-dark"
                  role="progressbar"
                  style={{ width: "100%" }}
                ></div>
              </div>
              <h2 className="fw-bold mb-4 review-title-dark">
                Revisão das Respostas
              </h2>
              <ul className="list-group-dark mb-3">
                {questions
                  .filter((q) => answers[q.id] !== undefined)
                  .map((q) => {
                    let answerText = answers[q.id];
                    if (q.type === "multiple-choice") {
                      const selected = q.options.find(
                        (opt) => opt.id === answers[q.id]
                      );
                      answerText = selected ? selected.label : answerText;
                    }

                    // orçamento (drag) → formata em R$ com separador
                    if (q.type === "drag" && typeof answerText === "string") {
                      const [min, max] = answerText
                        .split(" - ")
                        .map((v) => parseInt(v, 10));
                      const formatCurrency = (val) =>
                        val.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                          minimumFractionDigits: 0,
                        });
                      answerText = `${formatCurrency(min)} - ${formatCurrency(max)}`;
                    }
                    return (
                      <li key={q.id} className="list-group-item-dark p-3">
                        <div className="question-label-dark mb-2">
                          {q.label}
                        </div>
                        <div className="answer-text-dark">{answerText}</div>
                      </li>
                    );
                  })}
              </ul>
              <div className="buttons-row">
                <button className="btn-secondary-dark" onClick={handleBack}>
                  Voltar
                </button>
                <button
                  className="btn-success-dark"
                  onClick={handleConfirmAnswers}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card-dark">
            <div className="recomend-me-card-body-dark">
              <div className="progress-dark mb-3">
                <div
                  className="progress-bar-dark"
                  role="progressbar"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>

              <h2 className="question-text-dark fw-bold fs-4 mb-4">
                {questions[currentQuestionIndex]?.label}
              </h2>

              {questions[currentQuestionIndex]?.type === "multiple-choice" && (
                <div className="multiple-choice-dark">
                  {renderMultipleChoiceOptions(
                    questions[currentQuestionIndex].options
                  )}
                </div>
              )}

              {questions[currentQuestionIndex]?.type === "drag" &&
                renderSlider()}

              <div className="buttons-row">
                {history.length > 1 && (
                  <button className="btn-secondary-dark" onClick={handleBack}>
                    Voltar
                  </button>
                )}
                {questions[currentQuestionIndex]?.type === "drag" && (
                  <button
                    className="btn-primary-dark"
                    onClick={confirmPriceRange}
                  >
                    Confirmar orçamento
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecomendMe;
